import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import api from '../../services/api';

export default function LeadsReaquecidosList() {
  const { data, isLoading } = useQuery({
    queryKey: ['leads-reaquecidos'],
    queryFn: () => api.get('/leads/reaquecidos').then(r => r.data),
  });

  const leads = data?.data || [];

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold text-gray-800">Leads Reaquecidos</h1>
      </div>

      <div className="bg-white rounded-xl shadow overflow-hidden">
        {isLoading ? (
          <div className="p-8 text-center text-gray-400">Carregando...</div>
        ) : (
          <table className="w-full text-sm">
            <thead className="bg-gray-50 text-gray-600 text-xs uppercase tracking-wider">
              <tr>
                <th className="px-6 py-3 text-left">Nome</th>
                <th className="px-6 py-3 text-left">Telefone</th>
                <th className="px-6 py-3 text-left">Resumo da Conversa</th>
                <th className="px-6 py-3 text-left">Data</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-50">
              {leads.map(lead => (
                <tr key={lead.id} className="hover:bg-gray-50">
                  <td className="px-6 py-4 font-medium text-gray-800">{lead.contact_name}</td>
                  <td className="px-6 py-4 text-gray-600">{lead.phone}</td>
                  <td className="px-6 py-4 text-gray-600 text-xs max-w-md">{lead.resumo_conversa || '—'}</td>
                  <td className="px-6 py-4 text-gray-400 text-xs">
                    {lead.created_at ? format(new Date(lead.created_at), 'dd/MM/yyyy HH:mm', { locale: ptBR }) : '—'}
                  </td>
                </tr>
              ))}
              {!leads.length && (
                <tr><td colSpan={4} className="px-6 py-8 text-center text-gray-400">Nenhum lead reaquecido encontrado</td></tr>
              )}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
